import React, { useState } from 'react';
import { useOrderContext } from '@hooks';
import { ANIMATE_MAP } from '@constants';
import { AnimationLayout } from '@layouts';
import OrderItemsList from '../OrderItemsList';
import EllipsisGroup from '../EllipsisGroup';
import OrderInfo from '../OrderInfo/OrderInfo';
import { formateDateTime } from '@utils';
import { useStyles } from './styles';

const AccordionDetailsOrder = ({
  expanded,
  orderId,
  isNeitherCardExpandedYet,
  changeOrderGroupStatus,
  handleAccordionChange,
}) => {
  const classes = useStyles();
  const [isOpenModal, setOpenModal] = useState(false);
  const { orderItemData, isLoadingOrderItemData } = useOrderContext();

  const sessionString = localStorage.getItem('session');
  const sessionParsed = JSON.parse(sessionString);
  const isRunnerTypeUser = sessionParsed.staff.type === 'runner';

  const handleModalShow = isOpen => () => {
    setOpenModal(isOpen);
  };
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const animationObjectConfig =
    expanded && !isNeitherCardExpandedYet ? ANIMATE_MAP.slideInDownAnimate : {};

  return (
    <div className={classes.accordionDetailsInner}>
      <AnimationLayout animation={animationObjectConfig}>
        <OrderInfo
          orderItemId={orderItemData.id}
          orderCreated={formateDateTime(orderItemData.created, 'nl-NL')}
          orderStatus={orderItemData.status}
          orderPrice={orderItemData.priceIncludingTax}
        />
        <OrderItemsList
          orderId={orderId}
          expanded={expanded}
          isOpenModal={isOpenModal}
          orderItemData={orderItemData}
          isRunnerTypeUser={isRunnerTypeUser}
          isLoadingOrderItemData={isLoadingOrderItemData}
          handleModalShow={handleModalShow}
          handleModalClose={handleModalClose}
          changeOrderGroupStatus={changeOrderGroupStatus}
        />
        <EllipsisGroup
          id="" // needed for folding accordion
          expanded={expanded}
          handleAccordionChange={handleAccordionChange}
          color="gray"
        />
      </AnimationLayout>
    </div>
  );
};

export default AccordionDetailsOrder;
